/* eslint-disable max-len */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DorMeasurementFieldNames, LiftTrailStatus } from '@powdr/constants';
import { getLifts } from '@powdr/stores';
import { filterLiftTrailItemsBySeason } from '@powdr/utils';

export const useLiftsMeasurements = (
  ignoreLiftTypes,
  includeInOpenCount,
  sectors,
  season,
) => {
  const dispatch = useDispatch();
  const useLiftsData = useSelector((state) => state.lifts);
  const { data } = useLiftsData;
  const [liftsData, setLiftsData] = useState(null);

  useEffect(() => {
    dispatch(getLifts());
  }, [dispatch]);

  useEffect(() => {
    if (data && data?.length > 0) {
      setLiftsData({
        [DorMeasurementFieldNames.OPEN]: filterLiftTrailItemsBySeason(
          data
            .filter((l) => !ignoreLiftTypes.includes(l.type))
            .filter((l) => (l.status === LiftTrailStatus.OPEN || includeInOpenCount.includes(l.status)))
            .filter((t) => ((sectors?.length > 0)
              ? sectors?.includes(t.sector.id)
              : true)),
          season,
        ).length,
        [DorMeasurementFieldNames.TOTAL]: filterLiftTrailItemsBySeason(
          data
            .filter((l) => !ignoreLiftTypes.includes(l.type))
            .filter((t) => ((sectors?.length > 0)
              ? sectors?.includes(t.sector.id)
              : true)),
          season,
        ).length,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return liftsData;
};
